import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGAAndarBahar } from 'components/slots/PragmaticDGA/hooks';

import './AndarBahar.scss';

const b = block('pragmatic-dga-andar-bahar');

type AndarBaharProps = {
  results: PragmaticDGAAndarBahar['gameResult'];
};

export const AndarBahar = memo(({ results }: AndarBaharProps) => (
  <div className={b()}>
    {results.map(({ cardValue, winner }, index) => (
      <div key={index} className={b('result', { type: winner })}>{cardValue}</div>
    ))}
  </div>
), isEqual);
